import {useEffect, useRef, useState} from "react";
import SelectCustom from "../SelectCustom/SelectCustom";
import './ChooseBlock.css';

export const ChooseBlock = (props) => {
    const selectBlockRef = useRef();
    const [options, setOptions] = useState([]);
    const [chosenBlock, setChosenBlock] = useState();

    useEffect(() => {
        let options = [...props.blocks];

        if (props.disabledBlocks) {
            options = options.map(block => {
                const exist = props.disabledBlocks.find(disabledBlock => disabledBlock.id === block.blockId);
                if (exist) {
                    block.disabled = true;
                }
                return block;
            })
        }
        setOptions(options)
    }, [props.blocks]);

    useEffect(() => {
        props.onChange(chosenBlock)
    }, [chosenBlock]);

    return (
        <div className='choose-block-select'>
            <SelectCustom
                values={chosenBlock}
                placeholder='Wybierz blok do którego ma zostać dodane ustalenie'
                labelField='name'
                label='Wybierz blok'
                valueField='blockId'
                options={options}
                id='chooseBlockSelectId'
                dropdownId='chooseBlockDropdownId'
                onChange={(values) => setChosenBlock(values[0])}
                parentRef={selectBlockRef}
            />
        </div>
    )
};
